/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex, HeaderIcon, SVGIcon } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { SLATable } from "~/components/Runbook/NordcloudServices/SLATable";
import { ServiceAttachment } from "~/components/Services/types";
import { ButtonLink } from "~/components/Utils/ButtonLink";

type Props = {
  serviceAttachment: ServiceAttachment;
};

function ServiceWithSLA({ serviceAttachment }: Props) {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <>
      <ButtonLink onClick={() => setExpanded(!expanded)}>
        <Flex>
          <HeaderIcon animate={expanded}>
            <SVGIcon name="down" size="sm" />
          </HeaderIcon>

          {serviceAttachment.service.name}
        </Flex>
      </ButtonLink>

      {expanded && (
        <div className={styles.serviceSla}>
          {serviceAttachment.attachedSlas.length ? (
            <SLATable slas={serviceAttachment.attachedSlas} />
          ) : (
            <p className={styles.propertyValue}>No SLAs attached</p>
          )}
        </div>
      )}
    </>
  );
}

export { ServiceWithSLA };
